import * as Yup from "yup";

const documentoFreteNfeValidator = Yup.object().shape({
  serieNfe: Yup.number().nullable(),
  numeroNfe: Yup.number().nullable(),
  valorNfe: Yup.number().nullable(),
  pesoNfe: Yup.number().nullable(),
  chaveNfe: Yup.string()
    .max(44, "A chave da NF-e deve ter no máximo 44 caracteres")
    .nullable(),
});

export default documentoFreteNfeValidator;
